import React from 'react'
import styled from 'styled-components'
import { Button, Dropdown, Menu } from 'antd'
import R from 'ramda'
import cronstrue from 'cronstrue'

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.1em;
  margin-top: 15px;
  color: white;
  padding: 10px;
  background-color: steelblue;
  font-weight: bold;
  border-top-left-radius: 3px;
  height: 40px;
`

const Content = styled.div`
  overflow: auto;
  border-bottom: solid #ddd 1px;
  max-width: 100%;
  height: 100%;
  border-left: solid #ddd 1px;
  border-right: solid #ddd 1px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
`

const TriggerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  &:nth-child(even) {
    background-color: #eee;
  }
`

const toOption = trigger => ({
  key: trigger.triggerId,
  text: trigger.name,
  value: trigger.triggerId,
})

const toDescription = trigger => {
  try {
    return cronstrue.toString(trigger.cronExpression)
  } catch (e) {
    return undefined
  }
}

class Trigger extends React.PureComponent {
  remove = () => this.props.remove(this.props.trigger)
  render() {
    return (
      <TriggerContainer>
        <span title={toDescription(this.props.trigger)}>
          {this.props.trigger.name}
        </span>
        {!this.props.singleTrigger && (
          <Button
            style={{ marginRight: '0' }}
            onClick={this.remove}
            type="danger"
            ghost
            color="red"
          >
            X
          </Button>
        )}
      </TriggerContainer>
    )
  }
}

class JobTriggers extends React.PureComponent {
  onAddClicked = triggerId => {
    const { jobTriggers, updateTriggers, availableTriggers } = this.props
    updateTriggers([
      ...jobTriggers,
      R.find(t => t.triggerId === triggerId, availableTriggers),
    ])
  }

  onRemove = trigger => {
    const { jobTriggers, updateTriggers } = this.props
    updateTriggers(jobTriggers.filter(t => t.triggerId !== trigger.triggerId))
  }

  render() {
    const {
      jobTriggers = [],
      availableTriggers = [],
      className,
      style,
    } = this.props

    const options = R.compose(
      R.map(toOption),
      R.sortBy(t => t.name.toLowerCase()),
      R.filter(t1 => !R.any(t2 => t1.triggerId === t2.triggerId, jobTriggers))
    )(availableTriggers)

    return (
      <div style={style} className={className}>
        <Title>
          <span>Triggers</span>
          <Dropdown
            overlay={
              <Menu onClick={({ key }) => this.onAddClicked(key)}>
                {options.map(e => (
                  <Menu.Item key={e.key} value={e.value}>
                    {e.text}
                  </Menu.Item>
                ))}
              </Menu>
            }
          >
            <Button>Add</Button>
          </Dropdown>
          {/* <MenuDropdown
            options={options}
            onOptionSelected={this.onAddClicked}
            buttonProps={{ inverted: true, text: 'Add', size: 'mini' }}
            style={{ marginRight: '0px' }}
          /> */}
        </Title>
        <Content>
          {jobTriggers.map(t => (
            <Trigger
              key={t.triggerId}
              trigger={t}
              singleTrigger={jobTriggers.length === 1}
              remove={this.onRemove}
            />
          ))}
          {jobTriggers.length === 0 && <div>No Trigger assigned</div>}
        </Content>
      </div>
    )
  }
}

export default JobTriggers
